import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { _ } from 'underscore';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  showLogin = true;
  licenseHG: string;
  private loadNavigateByUrl = {
    faq: '/faq',
    precontact: '/faq/contact-us',
    privacypolicy: '/faq/privacy-policy',
    termsofservice: '/faq/terms-of-service',
    residential: '/',
    giveback: '/giveback',
    precontactmob: '/pre-contact',
    privacypolicymob: '/privacy-policy',
    termsofservicemob: '/terms-of-service',
    commercial: '/commercial',
    blog: '/blog',
  };
  constructor(private router: Router) {}
  ngOnInit() {
    this.licenseHG = `${new Date().getFullYear()} Honest Gorilla Inc. All Rights Reserved.`;
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      this.showLogin = false;
    }
  }
  footerClick(selectedMenu) {
    const scrollInitial = document.getElementsByTagName('html');
    scrollInitial[0].classList.add('letsgo');
    this.router.navigateByUrl(this.loadNavigateByUrl[selectedMenu]);
  }
}
